import { render, staticRenderFns } from "./ResultsDetailedSection.vue?vue&type=template&id=417d5dfc&"
import script from "./ResultsDetailedSection.vue?vue&type=script&lang=js&"
export * from "./ResultsDetailedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports